import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { serverApi } from "./config/Keys";
import { connect } from "react-redux";
import { Image } from "react-bootstrap";
import { Grid } from "@material-ui/core";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };

    if (this.props.showError === false) {
      this.state.error = null;
      this.state.errorInfo = null;
    }
  }
  //

  static getDerivedStateFromError = (error) => {
    return { hasError: true };
  };

  componentDidCatch = (error, info) => {
    this.setState({ error: error, errorInfo: info });
    let formData = {
      stack: error.stack,
      methodSource: info?.componentStack
        ? info?.componentStack
        : JSON.stringify(info),
      source: "FRONTEND",
    };
    if (this.props.auth?.user) {
      formData.user = {
        id: this.props.auth?.user?.VendorUser?._id || "",
        mobile: this.props.auth?.user?.VendorUser?.mobile_number || "",
        email: this.props.auth?.user?.VendorUser?.email || "",
        role: this.props.auth?.user?.VendorUser?.role || "",
      };
    }
    axios.post(`${serverApi}/errorHandler`, formData, {
      headers: {
        Authorization: this.props.auth?.accessToken || "",
        "Content-Type": "application/json",
      },
    });
  };

  render() {
    if (this.state.errorInfo) {
      return (
        <Grid
          style={{
            minHeight: "100vh"
          }}
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item style={{ marginTop: "20px" }}>
            <Image
              src={require("./assets/images/error.svg")}
              alt="Error Image"
              fluid
            />
          </Grid>
          <Grid item>
            <p style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>Oops, Something Went Wrong!</p><br />
            <p style={{ fontSize: "10px", textAlign: 'center' }}>Sorry, we can't get that information right now. Please try again later. If problem continues, contact your helpdesk.</p>
          </Grid>
        </Grid>
      );
    } else {
      return this.props.children;
    }
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(withRouter(ErrorBoundary));
